export var BundlingStatus;
(function (BundlingStatus) {
    BundlingStatus[BundlingStatus["Success"] = 0] = "Success";
    BundlingStatus[BundlingStatus["Overlaps"] = 1] = "Overlaps";
    BundlingStatus[BundlingStatus["EdgeSeparationIsTooLarge"] = 2] = "EdgeSeparationIsTooLarge";
})(BundlingStatus || (BundlingStatus = {}));
//# sourceMappingURL=BundlingStatus.js.map